"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
var Validations;
(function (Validations) {
    Validations["MaxDays"] = "online_event.dripping.days.description";
    Validations["Required"] = "validations.required";
})(Validations || (Validations = {}));
class DrippingValidation {
    constructor(hasDuration, liberationType) {
        this.hasError = false;
        this.hasDuration = hasDuration;
        this.liberationType = liberationType;
    }
    isEmpty(value) {
        return !value && value !== 0;
    }
    setHasError(validations) {
        this.hasError = Object.values(validations).some((validation) => validation.length > 0);
    }
    getErrors(validations) {
        return Object.entries(validations)
            .filter((entry) => entry[1])
            .map((entry) => entry[0]);
    }
    validateLiberationDays(liberationDays) {
        if (this.liberationType !== constants_1.LIBERATION_TYPE.BY_DAYS) {
            return [];
        }
        const validations = {
            [Validations.MaxDays]: Number(liberationDays) > constants_1.MAX_LIBERATION_DAYS,
            [Validations.Required]: this.isEmpty(liberationDays)
        };
        return this.getErrors(validations);
    }
    validateLiberationDate(liberationDate) {
        if (this.liberationType !== constants_1.LIBERATION_TYPE.BY_DATE) {
            return [];
        }
        const validations = {
            [Validations.Required]: this.isEmpty(liberationDate)
        };
        return this.getErrors(validations);
    }
    validateDurationDays(durationDays) {
        if (!this.hasDuration) {
            return [];
        }
        const validations = {
            [Validations.Required]: this.isEmpty(durationDays)
        };
        return this.getErrors(validations);
    }
    validate({ liberationDays, liberationDate, durationDays }) {
        const errors = {
            liberationDays: this.validateLiberationDays(liberationDays),
            liberationDate: this.validateLiberationDate(liberationDate),
            durationDays: this.validateDurationDays(durationDays)
        };
        this.setHasError(errors);
        return errors;
    }
}
DrippingValidation.initialState = {
    liberationDays: [],
    liberationDate: [],
    durationDays: []
};
exports.default = DrippingValidation;
